import SwiperBundle from 'swiper/bundle';
import 'swiper/css/bundle';

// Starsze szablony używają klasy swiper-container.
export default class Swiper extends SwiperBundle {
    constructor(element, options) {
        element.classList.add('swiper');
        super(element, options);
    }
}
